module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"subtitle":"- Only For You","title":"Recently Viewed"},"ar":{"subtitle":"- فقط لأجلك","title":"شوهد مؤخرا"}}')
  delete Component.options._Ctor
}
